<template>
    <CContainer>
        <CRow>
            <h6>
                Esta sección, le permite ver el histórico de las facturas que se han generado para la empresa. 
            </h6>
        </CRow>
      <CCard
        class="bg-light border-0 mt-4 mb-1">
        <CCardBody>
          <CDropdown
            color="dark"
            :caret="false"
            class="d-inline-block">
            <template v-slot:toggler>
              <CButton
                color="dark">
                <CIcon name="cil-cloud-download"/>
                <span class="align-middle ml-2">Descargar</span>
              </CButton>
            </template>
            <CDropdownItem>
              <json-excel
                :fields="fileFields"
                :data="items"
                name="historialcompras.xls"
                class="w-100">
                Excel
              </json-excel>
            </CDropdownItem>
            <CDropdownItem>
              <json-excel
                :fields="fileFields"
                :data="items"
                type="csv"
                name="historialcompras.csv"
                class="w-100">
              CSV
            </json-excel>
            </CDropdownItem>
          </CDropdown>
        </CCardBody>
      </CCard>
      <CCard class="mt-4">
        <CCardBody class="p-3">
          <CRow class="mt-3">
            <CCol sm="3">
              <div class="form-group" role="group">
                <label class="text-muted font-weight-bold col-sm-12" for="">Fecha Inicial: </label>
                <Datetime type="date" v-model="dateFrom" format="dd/MM/yyyy" :auto="true" class="col-sm-12 " input-class="col-sm-12 form-control text-right">
                  <template slot="button-cancel">
                    <span></span>
                  </template>
                  <template slot="button-confirm">
                    <span></span>
                  </template>
                </Datetime>
              </div>
            </CCol>
            <CCol sm="3">
              <div class="form-group" role="group">
                <label class="text-muted font-weight-bold col-sm-12" for="">Fecha Final: </label>
                <Datetime type="date" v-model="dateTo" format="dd/MM/yyyy" :auto="true" class="col-sm-12 " input-class="col-sm-12 form-control text-right">
                  <template slot="button-cancel">
                    <span></span>
                  </template>
                  <template slot="button-confirm">
                    <span></span>
                  </template>
                </Datetime>
              </div>
            </CCol>
            <CCol sm="3">
              <CSelect 
                class="col-sm-12"
                addLabelClasses="text-muted font-weight-bold" 
                label="Dependencia: " 
                :options="dependencies.map(item => { return { value: item.id_Dependencia, label: item.dependencia}})"
                :value.sync="selectedDependency"
                invalidFeedback="La Dependencia no ha sido asignada"/>
            </CCol>
            <CCol sm="3" class="d-flex align-items-end">
              <CButton color="info" class="mb-3" @click="getData()"><CIcon name="cil-reload"/><span class="ml-2 align-middle">Cargar</span></CButton>
            </CCol>
          </CRow>
          <CDataTable
            class="mx-3"
              :items="items"
              :fields="fields"
              :tableFilter="{label: 'Buscar: ', placeholder:' '}"
              :items-per-page-select="{label:'Items por página', values: [10, 20, 50]}"
              :items-per-page="10"
              hover
              pagination>
              <template #Valor_Total="{item}">
                <td align="right">{{formatter.format(item.Valor_Total, 0)}}</td>
              </template>

              <template #Fecha_Emision="{item}">
                <td align="right">{{moment(item.Fecha_Emision).format('DD/MM/YYYY')}}</td>
              </template>



              <template #Fecha_Vencimiento="{item}">
                <td align="right">{{moment(item.Fecha_Vencimiento).format('DD/MM/YYYY')}}</td>
              </template>
              <template #Numero="{item}">
                <td align="right">{{item.Numero}}</td>
              </template>
              <!-- <template #btn="{item}">
                <td >
                  <CButton 
                    color="info"
                    square
                    size="sm"
                    @click="getMovimientos(item.Id_Pedido)">
                    <CIcon name="cil-lightbulb"/>
                  </CButton>
                </td>
              </template> -->
          </CDataTable>
        </CCardBody>
      </CCard>
      <CElementCover  v-show="loading"/>    
    </CContainer>
</template>

<script>
  import moment from 'moment'
  import JsonExcel from 'vue-json-excel'
  import { formatter } from '../../general'
  import { dataListDependencias, dataGridVentasCliente } from '../../api'

  const fields = [
    { key: 'Dependencia', _style:'text-align:center;' },
    { key: 'Fecha_Emision', label: 'Emisión', _style:'text-align:center;' },
    { key: 'Fecha_Vencimiento',label: 'Vencimiento', _style:'text-align:center;' },
    { key: 'Prefijo', _style:'text-align:center;' },
    { key: 'Numero', _style:'text-align:center;' },
    { key: 'Valor_Total', label: 'Valor', _style:'text-align:center;' },
  ]

  const fileFields = {
    'Dependencia': 'Dependencia',
    'Emision': 'Fecha_Emision',
    'Vencimiento': 'Fecha_Vencimiento',
    'Prefijo': 'Prefijo',
    'Numero': 'Numero',
    'Valor': 'Valor_Total'
  }

  export default {
    name: 'HistoricSales',
    components: { JsonExcel },
    data () {
      return {
        items:[],
        fields,
        formatter,
        moment,
        fileFields,
        loading: false,
        dateFrom: '',
        dateTo: '',
        dependencies: [],
        selectedDependency: ''
        // movementItems,
        // movementFields
      }
    },
    methods: {
      async getData() {
        this.loading = true;
        
        try {
          const {response} = await dataGridVentasCliente(
            this,
            this.$store.state.user.data.id_Directorio,
            this.selectedDependency.length ? null : this.selectedDependency,
            moment(this.dateFrom).utc().format('YYYY-MM-DD'),
            moment(this.dateTo).utc().format('YYYY-MM-DD')
          )
          this.items = [...response]
        } catch {          
          this.$store.commit('setAlert', {
                color: "danger",
                message: 'Error al cargar datos',
                show: 5
            })
        } finally {
          this.loading = false
        }
      },
      async getDependencies(){
        try{
          const data = await dataListDependencias(this, this.$store.state.user.data.id_Directorio)
          this.dependencies = [{ id_Dependencia: '', dependencia: "Seleccionar" }, ...data]
        } catch {
          console.log()
        }
      }
    },
    async mounted(){
      this.dateFrom = moment().utc().startOf('year').format()
      this.dateTo = moment().utc().format()
      await this.getData()
      await this.getDependencies()
    },
    computed: {
      // dependency(){
      //   return this.$store.state.user.dependency
      // }
    }
  }
</script>